export default {
  path: 'remind-password',
  name: 'RemindPassword',
  component: () => import('@/app/auth/remindPassword/RemindPasswordContainer.vue'),
  meta: {
    title: 'TV24 | przypomnienie hasła',
    public: true,
    onlyWhenLoggedOut: true,
  },
};
